module.exports = __webpack_public_path__ + "img/facility-dashboard.72f793db.svg";